module.exports = __webpack_public_path__ + "img/pic01_index.8c00d7db.png";